import type { BlaestProduct } from "@/formatters/types";

const VariantAvailability = {
  Available: "available",
  ComingSoon: "coming_soon",
} as const;

export const formatCustomAttributes = (product: BlaestProduct) => {
  const availability =
    product.var_availability || VariantAvailability.Available;

  const features = product.pr_features
    ?.filter(
      feature => !!feature.icon && "url" in (feature.icon as { url?: string }),
    )
    .map(feature => ({
      icon: (feature.icon as { url?: string }).url as string,
      label: feature.label,
      displayIconOnCard: feature.displayIconOnCard === "1",
    }));

  const care = product.pr_care;
  const fabric = {
    text: product.pr_fabric,
    details: product.pr_fabric_details_text,
  };
  const filling = product.pr_filling;
  const lining = product.pr_lining;
  const fit = product.pr_fit_text;
  const keyFeatures = product.pr_key_features_text;

  return {
    modelDisclaimer: product.dis_model_disclaimer_value,
    isForcedSalePrice: !!(
      (product.var_30day_compliance_key &&
        product.var_30day_compliance_key === "1") ??
      false
    ),
    comingSoon: availability === VariantAvailability.ComingSoon,
    available: availability,
    labels: product.var_label ?? [],
    type: product.pr_type,
    swatch: product.sh_swatch,
    isNew: product.pr_new === "1",
    gender: product.dis_gender,
    isArchive: product.dis_is_archive_value === "1",
    displaySortOrder: Number.isNaN(product.dis_sort_order_value)
      ? undefined
      : Number(product.dis_sort_order_value),
    features,
    care,
    fabric,
    filling,
    fit,
    lining,
    keyFeatures,
  };
};
